import { render } from "./NFT.vue?vue&type=template&id=84b846ee&scoped=true"
import script from "./NFT.vue?vue&type=script&lang=js"
export * from "./NFT.vue?vue&type=script&lang=js"

import "./NFT.vue?vue&type=style&index=0&id=84b846ee&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84b846ee"]])

export default __exports__